// src/views/external-api.js

import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const ExternalApi = () => {
  const [message, setMessage] = useState('');
  const serverUrl = process.env.REACT_APP_SERVER_URL;

  const { getAccessTokenSilently } = useAuth0();

  const callApi = async () => {
    try {
      const response = await fetch(`${serverUrl}/dev/get-basic-response`);

      const responseData = await response.json();
      //const responseData = await response.text();
      setMessage(responseData.message);
    } catch (error) {
      setMessage(error.message);
    }
  };

  const callSecureApi = async () => {
    try {
      const token = await getAccessTokenSilently();
      console.log(token)
      //const token = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InhJSjM1QjlUM0c4ejhpODY1cDBCTSJ9.eyJpc3MiOiJodHRwczovL2Rldi14ZWIwYjNnZC51cy5hdXRoMC5jb20vIiwic3ViIjoiUDVNWmk4bzVqT0VDa1hhNzVkSXF0QmprTlViMW5zMEZAY2xpZW50cyIsImF1ZCI6Imh0dHBzOi8vMzF3Y2dkd3J6My5leGVjdXRlLWFwaS51cy1lYXN0LTEuYW1hem9uYXdzLmNvbS8iLCJpYXQiOjE2NjE2OTU3MDQsImV4cCI6MTY2MTc4MjEwNCwiYXpwIjoiUDVNWmk4bzVqT0VDa1hhNzVkSXF0QmprTlViMW5zMEYiLCJndHkiOiJjbGllbnQtY3JlZGVudGlhbHMifQ.do7SJ_tkp_Ypeqdih4MC0BNuIbHjQAsHYL4b42KGdIQsYv3oLblwg0Ia6hQswvYg1xlHXy3vlRd4j40239HEFB49plFfsabqylqpa8LxSUUeZ81wRlc_WC4wTXtzouy2IZiPtKOGEHBLMCFlcQQENlLWiS61L7o6fRXTPkn3RU_ghGwjSZRAV-0OA11f5vnrvR0ZvAUG_DgEJGFJhSlf-o_zuSgzGzmemVZ9W6B2kisYMOA9KeuwyJyaCN2IcqfpDxEe4yyN2awJBjTpxVQO0DrysCGxxujgl6w8YbnGkjplMbouEGnz1QY9dRill5tJHnJHxKdHiM0kIJfmA3Auyw'
      const json = JSON.stringify({ key1 : 'here', key2 : 'stuff' , key3 : 'Michael'});
      const requestOptions = {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify({ email : 'here', firstName : 'Michael' , lastName : 'Michael'}),
        headers: {
         Authorization: `Bearer ${token}`,
         Accept: 'application/json', 'Content-Type': 'application/json',
       }
      }
     
      const response = await fetch(
        `${serverUrl}/dev/hello-world-python`, requestOptions);
        
        const responseData = await response.json();
        console.log(responseData)
      setMessage(responseData.message);
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <div className="container">
      <h1>External API</h1>
      <p>
        Use these buttons to call an external API. The protected API call has an
        access token in its authorization header. The API server will validate
        the access token using the Auth0 Audience value.
      </p>
      <div
        className="btn-group mt-5"
        role="group"
        aria-label="External API Requests Examples"
      >
        <button 
          type="button" 
          className="btn btn-primary" 
          onClick={callApi}>
          Get Public Message
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={callSecureApi}
        >
          Get Protected Message
        </button>
      </div>
      {message && (
        <div className="mt-5">
          <h6 className="muted">Result</h6>
          <div className="container-fluid">
            <div className="row">
              The result should go here:
              <code className="col-12 text-light bg-dark p-4">{message}</code>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExternalApi;
